// extracted by mini-css-extract-plugin
module.exports = {"trigger":"addElement_trigger__19iTM","addElementContainer":"addElement_addElementContainer__3UpsJ"};